interface LogoProps {
  className?: string
  iconOnly?: boolean
}

export function Logo({ className = "", iconOnly = false }: LogoProps) {
  // Check if group-hover:hidden is being applied - need to handle dark mode explicitly
  const hasGroupHoverHidden = className.includes('group-hover') && className.includes('hidden')

  if (iconOnly) {
    return (
      <>
        <img
          src="/icon.svg"
          alt="Cayu"
          className={`dark:hidden ${className}`}
        />
        <img
          src="/icon-white.svg"
          alt="Cayu"
          className={`hidden dark:block ${hasGroupHoverHidden ? 'dark:group-hover/logo:hidden' : ''} ${className}`}
        />
      </>
    )
  }

  return (
    <>
      <img
        src="/logo-black.svg"
        alt="Cayu"
        className={`dark:hidden ${className}`}
      />
      <img
        src="/logo-white.svg"
        alt="Cayu"
        className={`hidden dark:block ${hasGroupHoverHidden ? 'dark:group-hover/logo:hidden' : ''} ${className}`}
      />
    </>
  )
}
